import { Link } from 'react-router-dom'
import nth from 'lodash/nth'

import ProductImage from '../modules/ProductImage'

import Card from './Card'

import { LineItem } from '../../types'

interface ItemQuantitiesInputProps {
  items: LineItem[]
  itemQuantities: Record<string, string>
  onChangeItemQuantities: (itemQuantities: Record<string, string>) => void
}

const ItemQuantitiesInput = ({
  items,
  itemQuantities,
  onChangeItemQuantities,
}: ItemQuantitiesInputProps) => (
  <Card.Section title="Items">
    <div className="mt-2">
      {items.map((item) => (
        <Card.SubSection key={item.id}>
          <div className="flex space-x-4 items-center">
            <img
              src={ProductImage.url(nth(item.product.images, 0), 'card')}
              alt={item.product.name}
              className="w-12 h-12 object-cover border rounded-sm"
            />
            <div className="flex-1">
              <Link to={`/products/${item.product.id}`} className="text-sm text-blue-500 underline">
                {item.product.name}
              </Link>
              <p className="text-sm text-gray-500">MPN: {item.product.mpn}</p>
            </div>
            <div className="flex shrink justify-end items-center">
              <input
                className="w-20 focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border-gray-300 rounded-md"
                type="number"
                step={1}
                min={0}
                max={item.quantity}
                value={itemQuantities[item.id]}
                onChange={(e) =>
                  onChangeItemQuantities({
                    ...itemQuantities,
                    [item.id]: e.target.value,
                  })
                }
              />
              <p className="text-sm text-gray-700 ml-2">of {item.quantity}</p>
            </div>
          </div>
        </Card.SubSection>
      ))}
    </div>
  </Card.Section>
)

export default ItemQuantitiesInput
